<template>
    <div v-if="initialized">
        <div
            class="af-form"
            v-if="!submited"
        >
            <C1Label class="afu-text-center af-label afu-text-black afu-block afu-mb-20 af-text--8xl afu-font-bold">
                <span>{{ form.title }}</span>
            </C1Label>
            <ValidationObserver
                ref="submitForm"
                tag="form"
                @submit.stop.prevent="onSubmit"
            >
                <div class="custom-candidate-attributes">
                    <CustomAttributeInput
                        v-for="(attr, index) in customAttributes"
                        :key="`custom_attribute_${attr.id}_${index}`"
                        :attr="attr"
                        :redirect-url=redirectUrl
                        @changed="changedCustomAttribute"
                    />
                </div>

                <AfTerms :terms="getTerms" />

                <C1Alert
                    v-if="!!response.message"
                    :variant="response.variant"
                >
                    <span v-html="response.message" />
                </C1Alert>

                <div class="afu-text-center afu-mt-10 afu-mb-32">
                    <C1Button
                        :disabled="loader.updating"
                        :is-busy="loader.updating"
                        type="submit"
                        variant="outline-primary"
                        class="afu-w-btn-sm"
                    >
                        {{ $t('label.submit') }}
                    </C1Button>
                </div>
            </ValidationObserver>
        </div>
        <div
            v-else
            class="afu-text-center afu-mt-10 afu-form-success"
        >
            <div
                v-if="return_page.notFound"
                class="af-notFound"
            >
                <div class="afu-text-10xl afu-text-center afu-mb-0">
                    {{ form_slug }} form not found
                </div>
            </div>
            <div
                v-if="return_page.success"
                class="af-success"
            >
                <div class="afu-text-10xl afu-text-center afu-mb-0">
                    Your submission was successful!
                </div>
            </div>
            <C1Button
                variant="primary"
                class="afu-mt-10"
                @click="redirectToHome()"
            >
                Return to home
            </C1Button>
        </div>
    </div>
</template>

<script>
    import { mapActions } from 'vuex';
    import '@/plugins/vee-validate';
    import '../../plugins/vee-validate';
    import Cookie from '@/services/cookie';
    import { ValidationObserver } from 'vee-validate';
    import C1Button from '@/components/C1Components/C1Button';
    import C1Alert from '@/components/C1Components/C1Alert';
    import C1Label from '@/components/C1Components/C1Label';
    import CustomAttributeInput from '@/components/Seeker/CustomAttributeInput';
    import AfTerms from '@/components/Partials/AfTerms';

    export default {
        name: 'CustomForm',

        components: {
            ValidationObserver,
            CustomAttributeInput,
            C1Button,
            C1Alert,
            C1Label,
            AfTerms,
        },

        data() {
            return {
                response: {
                    variant: '',
                    message: '',
                },
                loader: {
                    updating: false,
                },
                initialized: false,
                submited: false,
                form_slug: '',
                customAttributes: [],
                return_page: {
                    notFound: false,
                    success: false,
                },
                form: {
                    id: '',
                    title: '',
                },
                redirectUrl: null,
                profileUpdateAllowed: false,
            };
        },

        async created() {
            if (window?.customFormParams?.slug) {
                this.form_slug = window.customFormParams.slug;
            } else {
                this.form_slug = this.$route.params.form_slug;
            }
            this.$_getCustomForm({ formSlug: this.form_slug })
                .then(response => {
                    if (response.data) {
                        this.form = {
                            id: response.data.id,
                            title: response.data.title,
                        };
                        if (response.data.allow_profile_update) {
                            this.redirectUrl = window.location.pathname;
                        }
                        this.profileUpdateAllowed = response.data.allow_profile_update;
                        response.data.fields.forEach(attr => {
                            if (attr.type === 'select') {
                                let op;

                                if (attr.misc?.typeahead) {
                                    op = attr.value;
                                    attr.model = attr.value?.label;
                                } else {
                                    op = attr.options.find(
                                        op => op.id == attr.value,
                                    );
                                }

                                if (op) {
                                    attr.value = { ...op };
                                } else {
                                    attr.value = '';
                                }
                            }

                            if (attr.type === 'multiselect') {
                                if (Array.isArray(attr.value)) {
                                    if (attr.misc?.typeahead) {
                                        attr.value = attr.value.map(op => {
                                            return {
                                                id: op.id,
                                                label: op.label,
                                            };
                                        });
                                    } else {
                                        attr.value = attr.value.map(op => {
                                            const option = attr.options.find(
                                                ele => ele.id == op,
                                            );
                                            return {
                                                id: option.id,
                                                label: option.label,
                                                is_selected: true,
                                            };
                                        });
                                    }     
                                } else {
                                    attr.value = [];
                                }
                            }

                            if (attr.type === 'file' || attr.type === 'image') {
                                if (attr.file) {
                                    attr.value = {
                                        name: attr.file.filename,
                                        lastModifiedDate: attr.file.updated_at,
                                        uuid: attr.file.uuid,
                                        size: attr.file.size,
                                        extension: attr.file.filename
                                            .split('.')
                                            .pop(),
                                    };
                                } else {
                                    attr.value = null;
                                }
                            }
                        });
                        this.customAttributes = response.data.fields;
                    }
                })
                .catch(() => {
                    this.submited = true;
                    this.return_page.notFound = true;
                })
                .finally(() => {
                    this.initialized = true;
                });

            await this.$recaptchaLoaded();
        },

        computed: {
            getTerms() {
                let terms = window?.afConfig?.terms_content;
                if (terms) {
                    terms = JSON.parse(terms);
                } else {
                    terms = [];
                }
                return terms;
            },

            userLoggedIn() {
                const token = Cookie.getToken();
                return (token) ? true : false;
            },
        },

        watch: {},

        async mounted() {},

        methods: {
            ...mapActions('site', {
                $_getCustomForm: 'getCustomForm',
            }),

            ...mapActions('auth', {
                $_register: 'register',
            }),

            ...mapActions('user', {
                $_checkEmail: 'checkEmail',
            }),

            ...mapActions('me', {
                $_updateDetails: 'updateDetails',
            }),

            async onSubmit() {
                const validate = await this.$refs.submitForm.validate();
                if (!validate) {
                    return;
                }

                const token = await this.$recaptcha('register_custom');
                if (!token) {
                    return;
                }

                this.loader.updating = true;

                const customAttributes = this.customAttributes.map(attribute => {
                    const ele = { ...attribute };
                    if (ele.type == 'multiselect') {
                        ele.value = ele.value?.map(value => value.id);
                    }
                    if (ele.type == 'select') {
                        ele.value = ele.value?.id;
                    }
                    if (ele.type == 'checkbox') {
                        ele.value = ele.value ? 1 : 0;
                    }

                    return ele;
                });

                const customFields = customAttributes
                    .filter(ele => {
                        return ele.category == 'site';
                    })
                    .map(ele => {
                        return {
                            id: ele.field_id,
                            value: ele.value,
                        };
                    });

                const platformFields = customAttributes
                    .filter(ele => {
                        return ele.category == 'platform' && ele.slug;
                    })
                    .reduce((memo, ele) => {
                        memo[ele.slug] = ele.value;
                        return memo;
                    }, {});

                let formData = platformFields;

                formData = {
                    ...formData,
                    custom_fields: customFields,
                    token: token,
                };
                if (this.profileUpdateAllowed && this.userLoggedIn) {
                    this.saveCustomFieldResponses(formData);
                } else {
                    this.$_register(formData)
                        .then(response => {
                            if (response) {
                                this.response.variant = 'success';
                                this.response.message = 'form submitted successfully.';
                                this.$emit('formSubmitted');
                                this.submited = true;
                                this.return_page.notFound = false;
                                this.return_page.success = true;
                            }
                        })
                        .catch(error => {
                            const errorCode =
                                error?.response?.data?.error || 'ServerErrorException';
                            this.response.variant = 'danger';

                            if (errorCode == 'RecaptchaTokenInvalid') {
                                this.response.message = error?.response?.data?.message;
                            }
                            else {
                                this.response.message = 'Can not submit the form, please refresh and try again.';
                            }
                        })
                        .finally(() => {
                            this.loader.updating = false;
                        });
                }
            },

            redirectToHome() {
                window.location.href = this.getLocalePath('/');
            },

            changedCustomAttribute() { },

            saveCustomFieldResponses(formData) {
                this.$_updateDetails(formData).then((response) => {
                    console.log(response);
                    this.response.variant = 'success';
                    this.response.message = 'form updated successfully.';
                    this.$emit('formSubmitted');
                    this.submited = true;
                    this.return_page.notFound = false;
                    this.return_page.success = true;
                }).catch(error => {
                    const errorCode = error?.response?.data?.error || 'ServerErrorException';
                    this.response.variant = 'danger';
                    if (errorCode == 'RecaptchaTokenInvalid') {
                        this.response.message = error?.response?.data?.message;
                    }
                    else {
                        this.response.message = 'Can not submit the form, please refresh and try again.';
                    }
                }).finally(() => {
                    this.loader.updating = false;
                });
            },
        },
    };
</script>
<style lang="scss" scoped>
    .searchbar-typeahead {
        &::v-deep {
            .af-input-icon-x {
                top: 55%;
            }

            // .af-input {
            //     border: 0;
            // }
        }
    }
</style>
